import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {stepComponent} from './Info'
import './Steps.sass'

class Steps extends PureComponent {
  static propTypes = {
    color: PropTypes.string,
    selectedOption: PropTypes.string,
    procedure: PropTypes.shape().isRequired
  }

  static defaultProps = {
    color: 'primary',
    selectedOption: 'online'
  }

  render() {
    const {selectedOption , procedure, color} = this.props
    return (
      <div className="steps-wrapper">
        {/* eslint-disable */}
        {procedure && procedure[selectedOption].steps.map((select, index)=>{
          const StepComponent = stepComponent(select.component)
          return(
            <ul key={index} className={`steps ${color}`}>
              <li className="steps__caption">
                <span>{index+1}</span>
                {select.caption}
              </li>
              <li className="steps__content">
                <StepComponent info={select.info} />
              </li>
            </ul>
          )
        })}
        {/* eslint-disable */}
      </div>
    )
  }
}

export default Steps



// WEBPACK FOOTER //
// ./components/Service_Steps/index.jsx